import css from './form.module.scss';

import { range } from 'lodash';
import { memo } from 'react';

import { TEditorConfig } from 'com/Editor/Editor/interface';
import Button from 'core/ui/Button';
import { FormGroup, FormInput, Textarea } from 'core/ui/Form';
import { ImageInput } from 'core/ui/ImageInput';
import ICONS from 'core/ui/icons';

import { useOnMarkAsCorrect } from './useOnMarkAsCorrect';
import { useOnPaste } from './useOnPaste';

const QuestionEditorForm: TEditorConfig<
  TTest,
  TQuestion,
  TQuestionUpdate
>['Form'] = ({ editingEntity: editingQuestion, onChange }) => {
  const onPaste = useOnPaste(onChange);
  const onMarkAsCorrect = useOnMarkAsCorrect(editingQuestion, onChange);

  return (
    <>
      <FormGroup title="Main">
        <div className={css.rowWithButton}>
          <Textarea
            placeholder="Question"
            name="question"
            value={editingQuestion.question}
            onChange={onChange}
            autoSize
          />
          <Button theme="flat" onClick={onPaste} children={ICONS.Paste} />
        </div>
        <FormInput
          placeholder="Hint"
          name="hint"
          value={editingQuestion.hint || ''}
          onChange={onChange}
        />
        <ImageInput
          name="resourceBinary"
          resourceUid={editingQuestion.resourceUid}
          resourceBinary={editingQuestion.resourceBinary}
          onChange={onChange}
        />
      </FormGroup>

      <FormGroup title="Options">
        {range(editingQuestion.options.length + 1).map(idx => (
          <div className={css.rowWithButton} key={`options.${idx}`}>
            <Textarea
              placeholder={idx === 0 ? 'Right answer' : `Wrong option ${idx}`}
              name={`options.${idx}`}
              value={editingQuestion.options[idx] || ''}
              onChange={onChange}
              autoSize
            />
            <Button
              theme="flat"
              onClick={() => onMarkAsCorrect(idx)}
              children={ICONS.Active}
              disabled={idx === 0 || !editingQuestion.options[idx]}
              title={idx === 0 ? `It's the correct answer` : 'Mark as correct'}
            />
          </div>
        ))}
      </FormGroup>
    </>
  );
};

export default memo(QuestionEditorForm);
